/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ChartType } from '@models/chart.model';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-axes-grid-lines-line-width',
  templateUrl: './theme-option-axes-grid-lines-line-width.component.html',
  styleUrls: ['./theme-option-axes-grid-lines-line-width.component.css']
})
export class ThemeOptionAxesGridLinesLineWidthComponent {

  @Input() themeOptions: ThemeOptionsClass;
  @Input() axesIndex: number;
  @Input() axesXY: 'x' | 'y';

  showDetails: boolean;
  color = ItemColor('themes');
  optionType: ThemeOptionType = 'axes_gridLines_lineWidth';

  constructor() {
    this.showDetails = false;
  }

  receiveValue(value: string, type?: ChartType) {
    this.themeOptions.setAxes(this.optionType, value, this.axesXY, this.axesIndex, type ? [type] : undefined);
  }

  receiveShowDetails(showDetails: boolean) {
    this.showDetails = showDetails;
  }

}
